<template>
  <div>
    <!-- <button class="btn btn-danger btn-icon" @click="$modal.show('re-paymart')">
      RE PAYMART
    </button>
    <modal name="re-paymart">
      <card>
        <label>{{ "select_partner" | setText("Выберите партнера") }}</label>
        <selector v-model="partner" modal="partner" selectKey="name"></selector>
        <template v-if="partner">
          <h4 v-if="!dateAt">Начать перезагрузку PAYMART</h4>
          <h4 v-else-if="dateAt">Процесс запущен {{ dateAt }}</h4>
          <button
            :disabled="isStarted"
            v-if="isStarted === false && isDone === false"
            class="btn btn-info btn-icon w-100"
            @click="start"
          >
            <span class="ti-upload"></span>
            Начать
          </button>
          <h4 v-if="isStarted === true && isDone === false">
            Идет выгрузка...
          </h4>
          <download-excel
            v-if="isDone === true"
            :data="data"
            :fields="exportFields"
            :name="'_export.xls'"
          >
            <button :disabled="isStarted" class="btn btn-info btn-icon w-100">
              <span class="ti-upload"></span> Скачать Excel
            </button>
          </download-excel>
          <hr />
          <button
            :disabled="isStarted"
            class="btn btn-warning btn-icon w-100"
            @click="cancel"
          >
            Отмена / сброс
          </button>
        </template>
      </card>
    </modal> -->
  </div>
</template>
<script>
import downloadExcel from "vue-json-excel";
export default {
  components: {
    downloadExcel,
  },
  name: "export",
  props: {
    exportFields: {
      default: function () {
        return {};
      },
    },
    params: {
      default: function () {
        return {};
      },
    },
    itemLink: {
      default: function () {
        return "";
      },
    },
  },
  methods: {
    cancel() {
      this.$modal.hide("re-paymart");
      this.isDone = false;
      this.isStarted = false;
      this.dateAt = null;
    },
    start() {
      this.$dialog
        .confirm(
          "Вы точно хотите начать? Это может занять несколько минут, в зависимости от кол-во товаров.",
          {
            okText: "Начать экспорт",
            cancelText: "Отмена",
          }
        )
        .then(() => {
          this.page = 1;
          this.data = [];
          this.$loading(true);
          this.isStarted = true;
          this.dateAt = new Date();
          this.export();
        })
        .catch(() => {});
    },
    async paymart() {
      for (let i = 0; i < this.data.length; i++) {
        const item = this.data[i];

        let act = await this.createFile(item["act"]);

        let photo = await this.createFile(item["client_product"]);

        if (act) {
          this.uploadAct(act, item);
        }

        if (photo) {
          this.uploadPhoto(photo, item);
        }
      }

      this.$loading(false);
    },
    async uploadAct(file, item) {
      let bodyFormData = new FormData();
      bodyFormData.append("id", item["exchange_id"]);
      bodyFormData.append("act", file);
      return this.$http({
        url: `${this.partner["endpoint_url"]}contracts/upload/act`,
        method: "POST",
        data: bodyFormData,
        headers: {
          Authorization: `Bearer ${this.partner["api_secret_key"]}`,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          if (
            response.data &&
            response.data.status &&
            response.data.status === "success"
          ) {
            this.update(item, "is_act_verified");
          }
          this.$loading(false);
        })
        .catch((error) => {
          //console.log("partner_upload_akt", item);
        })
        .finally(() => {});
    },
    async uploadPhoto(file, item) {
      let bodyFormData = new FormData();
      bodyFormData.append("id", item["exchange_additional_id"]);
      bodyFormData.append("client_photo", file);
      return this.$http({
        url: `${this.partner["endpoint_url"]}contracts/upload-client-photo`,
        method: "POST",
        data: bodyFormData,
        headers: {
          Authorization: `Bearer ${this.partner["api_secret_key"]}`,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          if (
            response.data &&
            response.data.status &&
            response.data.status == "success"
          ) {
            this.update(item, "is_photo_verified");
          }
        })
        .catch((error) => {
         // console.log("partner_upload_photo", item);
        })
        .finally(() => {});
    },
    async createFile(url = null) {
      if (!url) {
        return null;
      }

      try {
        let response = await fetch(url);

        var filename = url.substring(url.lastIndexOf("/") + 1);

        let data = await response.blob();

        const file = new File([data], filename, { type: data.type });

        return file;
      } catch (error) {}

      return null;
    },
    async export() {
      let params = JSON.parse(JSON.stringify(this.params));
      params["page"] = this.page;
      params["per_page"] = 100;
      await this.$http
        .get(this.itemLink, {
          params: params,
        })
        .then((response) => {
          if (response.data && response.data.data) {
            if (response.data.data.length) {
              this.data.push(...response.data.data);
              this.page++;
              setTimeout(() => {
                this.export();
              }, 10);
            } else {
              this.isDone = true;
              this.isStarted = false;
              this.paymart();
            }
          }
        })
        .catch(() => {
          this.$loading(false);
        })
        .finally(() => {});
    },

    async update(item, type = "is_photo_verified") {
      let data = {};
      data[type] = 1;

      if (type) {
        this.$http
          .put(`transactions/${item["id"]}`, data)
          .then((response) => {})
          .catch(() => {});
      }
    },
  },
  data() {
    return {
      isStarted: false,
      isDone: false,
      dateAt: null,
      data: [],
      page: 1,
      partner: null,
    };
  },
};
</script>
<style>
</style>
